"use strict";
const dataAttr = (condition) => condition ? "" : void 0;

export { dataAttr };
